<template>
  <div>
    <el-card>
      <el-row :gutter="20">
        <el-col :sm="24" :md="12" :lg="4">
          <el-cascader
            clearable
            v-model="courseIds"
            :show-all-levels="false"
            :props="subjectTreeProps"
            collapse-tags
            placeholder="请输入所属科目"
            :options="subjectTreeList"
            @change="subjectSearchChange"
          ></el-cascader>
        </el-col>
        <el-col :sm="24" :md="12" :lg="4">
          <el-input v-model="searchForm.name" placeholder="请输入商品名称" auto-complete="off" clearable></el-input>
        </el-col>
        <el-col :sm="24" :md="12" :lg="4" style="text-align:right;float:right">
          <el-button type="primary" @click="page.pageNumber = 1,pageList()" icon="el-icon-search">查询</el-button>
          <!-- <a @click="reset" class="mainColor ml">重置</a> -->
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <el-row>
        <el-col :span="12">
          <el-button type="danger" :loading="deleteGoodsInfoBlock" @click="deleteGoodsInfo()">删除{{number}}个商品</el-button>
        </el-col>
        <el-col :span="12" style="text-align:right">
          <el-button type="primary" @click="goCommodityCenter()">商品中心</el-button>
        </el-col>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" show-overflow-tooltip label="商品" width="300">
          <template slot-scope="row">
            <el-row>
              <el-col :span="8">
                <span>
                  <!-- <img :src="row.row.logo" /> -->
                  <img
                    style="margin-right:10px;"
                    width="100%"
                    height="44px"
                    :src="row.row.logo?row.row.logo:'../../../static/image/noImg.png'"
                  />
                </span>
              </el-col>
              <el-col :span="16">
                <span
                  style="color:rgb(36, 210, 181);margin-left:10px;"
                  v-if="row.row.recommend=='1'"
                >{{"[推荐]"}}</span>
                <span
                  style="color:rgb(36, 210, 181);margin-left:10px;"
                  v-if="row.row.hot=='1'"
                >{{"[热门]"}}</span>
                <span style="margin-left:10px;">{{row.row.name}}</span>
                <span style="display:block;margin-left:10px;">
                  <span style="color:red">￥{{row.row.price}}</span>
                  <span
                    style="text-decoration:line-through;color:rgb(162,170,188)"
                  >￥{{row.row.originalPrice}}</span>
                </span>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="type"
          width="100"
          align="center"
          label="类型"
          :render-header="renderSpecNameHeader"
        ></el-table-column>
        <el-table-column show-overflow-tooltip prop="subjectCourseName" label="所属科目" align="center"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="validDay"
          width="100"
          label="有效期"
          align="center"
        >
          <template slot-scope="row">{{row.row.validDay}}天</template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="100"
          prop="agentPrice"
          label="销量/库存"
          align="center"
        >
          <template slot-scope="row">
            <span>{{row.row.sellCount}}/{{row.row.stock}}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="100"
          prop="agentPrice"
          label="代理价（元）"
          align="center"
        >
          <template slot-scope="row">
            <span style="color:red;font-weight:bold">{{row.row.price}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="sell" label="状态" width="100" align="center">
          <template slot-scope="row">{{row.row.sell=="1"?"上架":"下架"}}</template>
        </el-table-column>
        <!-- <el-table-column show-overflow-tooltip width="50" prop="goodsItemCount" label="内容"></el-table-column> -->
        <el-table-column prop label="操作" width="80" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <!-- <span class="mainColor" @click="goodsItem(scope.row)">查看</span>
              <span class="mainColor" @click="goodsItem(scope.row)">编辑</span>-->
              <!-- <i class="el-icon-edit icon-style" title="编辑" @click="editGoods(scope.row)"></i> -->
              <i
                class="el-icon-view mainColor"
                style="font-size:20px"
                title="查看"
                @click="goGoodsInfo(scope.row)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, prev, pager, next"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
      <el-dialog title="设置商品价格" :visible.sync="agentPriceVisible" width="450px" left :close-on-click-modal="false">
        <el-form
          ref="editForm"
          :model="editForm"
          :label-width="formLabelWidth"
          :rules="editFormRules"
        >
          <el-form-item label="商品价格" prop="price">
            <el-input v-model="editForm.price" placeholder="请输入商品价格">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align:right">
          <el-button @click="agentPriceVisible = false">取 消</el-button>
          <el-button type="primary" @click="addGoodsAgentPrice">确 定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SelectHeader from "./SelectHeader";
export default {
  data() {
    return {
      deleteGoodsInfoBlock: false,
      agentPriceVisible: false,
      tableData: [],
      addgoodsAgentPrice: {},
      subjectTreeList: [], //科目
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true
      },
      typeList: [],
      number: 0,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      editForm: {},
      editFormRules: {
        price: [
          {
            required: true,
            message: "请输入商品价格",
            trigger: "blur"
          }
        ]
      },
      createTime: "",
      courseIds: [],
      searchForm: {
        courseIds: [],
        name: ""
      },
      loading: true,
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: [],
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/goodsInfo/upload`,
      fileList: [],
      updatePageId: "",
      goodsId: "",
      updatePageGoodsItem: ""
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    }
  },
  methods: {
    goCommodityCenter() {
      this.$router.push({
        path: "/commodityCenter"
      });
    },
    goGoodsInfo(row) {
      this.$router.push({
        path: "/goGoodsInfo",
        query: {
          id: row.id
        }
      });
    },
    editGoods(row) {
      this.api.goodsInfo.getGoodsInfo({ id: row.id }).then(result => {
        if (result.success) {
          this.editForm = result.data;
          this.agentPriceVisible = true;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    subjectSearchChange() {
      if (this.courseIds) {
        this.searchForm.subjectIds = [];
        this.courseIds.forEach(item => {
          this.searchForm.subjectIds.push(item[1]);
        });
      } else {
        this.searchForm.subjectIds = [];
      }
    },
    getSubjectTreeList() {
      // 获取课程
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  delete items.children;
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = [];
      val.forEach(e => {
        this.multipleSelection.push({ id: e.id });
      });
      this.number = this.multipleSelection.length;
      // this.multipleSelection = val;
    },
    //获取数据
    getGoodsInfo() {
      this.api.goodsInfo
        .getGoodsInfo({
          id: this.$route.query.updatePage
        })
        .then(result => {
          this.editForm = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addGoodsAgentPrice() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.goodsInfo.updateGoodsInfo(this.editForm).then(result => {
            if (result.success) {
              this.$message.success(result.message);
              this.agentPriceVisible = false;
              this.editForm = {};
              this.pageList();
            } else {
              this.$message.error(result.message);
            }
          });
        }
      });
    },
    deleteGoodsInfo() {
      if (this.deleteGoodsInfoBlock) {
        return false;
      }
      this.$confirm("将会删除选中商品，是否确认删除？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          setTimeout(() => {
            this.deleteGoodsInfoBlock = false;
          });
          this.deleteGoodsInfoBlock = true;
          this.api.goodsInfo
            .deleteGoodsInfo(this.multipleSelection)
            .then(result => {
              if (result.success) {
                this.page.pageNumber = 1;
                this.deleteGoodsInfoBlock = false;
                this.pageList();
              } else {
                this.deleteGoodsInfoBlock = false;
                this.$message.error(result.message);
              }
            });
        })
        .catch(() => {});
    },
    pageList() {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.goodsInfo
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          // for (let i in this.page.rows) {
          //   this.page.rows[i].tags = this.page.rows[i].tags.split(" ");
          // }
          this.page.total = result.data.total;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    renderSpecNameHeader(createElement, { column, $index }) {
      let self = this;

      return createElement(
        "div",
        {
          style: "display:flex;padding:0px;margin-left:20px"
        },
        [
          createElement("div", {
            domProps: {
              innerHTML: column.label
            }
          }),
          createElement(SelectHeader, {
            style: "cursor: pointer;",
            // 组件 prop
            props: {
              type: "order",
              options: self.specIdOptions, //下拉框选项
              defaultValue: self.specId, //默认值
              defaultProps: {
                value: "specId",
                label: "specName"
              }
            },
            // 事件监听器在 `on` 属性内，
            // 但不再支持如 `v-on:keyup.enter` 这样的修饰器。
            // 需要在处理函数中手动检查 keyCode。
            on: {
              selectChange: self.selectChange
              // click: this.clickHandler
            },
            // 仅用于组件，用于监听原生事件，而不是组件内部使用
            // `vm.$emit` 触发的事件。
            nativeOn: {
              // click: this.nativeClickHandler
            }
          })
        ]
      );
    },
    //选择框回调
    selectChange(val) {
      this.page.pageNumber = 1;
      this.searchForm.type = val;
      this.pageList();
      //写点啥吧
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    }
  },
  watch: {},
  mounted() {
    this.pageList();
    this.getSubjectTreeList();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/agencyGoods/index.vue